import Button from "@mui/material/Button";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { type ErrorComponentProps, useNavigate } from "@tanstack/react-router";

interface ErrorFallbackProps {
	reset: () => void;
}

export const ErrorFallback = ({ reset }: ErrorFallbackProps) => {
	const navigate = useNavigate();
	const { reset: resetQuery } = useQueryErrorResetBoundary();

	const handleUnderstand = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		try {
			resetQuery();
			reset();
		} catch (e) {
			navigate({ to: "/" });
		}
	};
	return (
		<div className="container h-full w-full flex flex-col justify-center items-center gap-2 bg-gradient-account">
			<h1 className="text-white text-2xl font-semibold leading-9">
				Oops, something went wrong!
			</h1>

			<div className="h-2" />

			<p className="text-white text-base leading-5 ">
				We apologize for the inconvenience. Our team is already on it to get
				things back on track.
			</p>

			<div className="h-8" />

			<Button
				size="large"
				variant="contained"
				color="primary"
				className="!rounded-full !h-14"
				onClick={handleUnderstand}
			>
				UNDERSTAND
			</Button>
		</div>
	);
};

const ErrorPage = (props: ErrorComponentProps) => {
	return <ErrorFallback reset={props.reset} />;
};

export default ErrorPage;
